const compareObjects = (initial: any, modified: any): any => {
  if (initial === modified) return undefined;

  if (initial && modified && typeof initial === 'object' && typeof modified === 'object') {
    const diff: Record<string, unknown> = {};
    for (const key of Object.keys(initial)) {
      const value = compareObjects(initial[key], modified[key]);
      if (value !== undefined) {
        diff[key] = value;
      }
    }
    return Object.keys(diff).length ? diff : undefined;
  }

  return modified;
};
// TODO - modify function to use getDifferenceInValues function for arrays
export const getDifferentProperties = <T extends Record<string, any>>(initialValues: T, modifiedValues: T): Partial<T> => {
  return compareObjects(initialValues, modifiedValues) || {};
};
